(function ($) {
	var isMobile = setIsMobile($(window).width());

	function setIsMobile(width) {
		return width < 900;
	}

	$(window).resize(function () {
		isMobile = setIsMobile($(window).width());
	});

	// Main menu hover
	const menuItemsWithChildren = $('#primary-menu>li.menu-item-has-children');
	let hoverTimeout;

	menuItemsWithChildren.on('mouseenter', function () {
		if (!isMobile) {
			const menuItem = $(this);
			hoverTimeout = setTimeout(function () {
				menuItem.addClass('hovered');
			}, 200);
		}
	});

	menuItemsWithChildren.on('mouseleave', function () {
		if (!isMobile) {
			clearTimeout(hoverTimeout);
			$(this).removeClass('hovered');
		}
	});

	// Set menu css variables
	function haseSubMenu(menuItem) {
		return menuItem.find('ul').length > 0 ? true : false;
	}

	const menuItems = $('#primary-menu>li');
	if (menuItems.length > 0) {
		menuItems.each(function () {
			if (haseSubMenu($(this))) {
				const subMenu = $(this).find('ul');
				const subMenuTitle = $(this).find('a span').first().text();
				subMenu.css("--title", '"' + subMenuTitle + '"');
			}
		});
	}

	//Mobile menu
	// Add sub levels artifacts
	const menu = $('#primary-menu');

	$('#primary-menu .sub-menu').each(function () {
		$('<li class="menu-back-btn"></li>')
			.on('click', function () {
				window.setTimeout(function () {
					// Add delay to animate.
					menu.find('li.sub-menu-opened').last().removeClass('sub-menu-opened');
				}, 200);
				menu.parent().removeClass('show-level-2');
			})
			.prependTo($(this));
	});

	// Navigation to second level
	$("#primary-menu .menu-item-has-children > a").on('click', function (event) {
		if (isMobile) {
			event.preventDefault();

			$(this).parent().addClass('sub-menu-opened');
			menu.parent().addClass('show-level-2');
		}
	});

	//Mobile menu basic logic
	$('.navbar-toggler').on('click', function (event) {
		event.preventDefault();

		$('body').toggleClass('menu-open');
		$(this).attr('aria-expanded') === 'false'
			? $(this).attr('aria-expanded', 'true')
			: $(this).attr('aria-expanded', 'false');
		$('.menu-back-btn').trigger('click');
	});
}(jQuery));